const colors = {
  background: "whitesmoke",
  textcolor: "black",
  highlight: "#ff0000"
};

export default colors;
